import { AfterViewInit, Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { Notifica } from '../_model';
import { Constants } from '../_utility';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificheFirestoreService {

  private _newNotify!: AngularFirestoreCollection<Notifica>;
  private _oldNotify!: AngularFirestoreCollection<Notifica>;

  constructor(private db: AngularFirestore, private authService: AuthService) { }

  get newNotify() {
    if (!this._newNotify) {
      this.getCollectionNewNotify();
    }
    return this._newNotify.valueChanges();
  }

  get oldNotify() {
    if (!this._oldNotify) {
      this.getCollectionOldNotify();
    }
    return this._oldNotify.valueChanges();
  }

  getCollectionNewNotify() {
    let id = this.authService.user.firebaseId;

    this._newNotify = this.db.collection(Constants.NotificheFirestoreService.BELL_PATH(id), ref => ref.where("show", "==", true));
  }

  getCollectionOldNotify() {
    let id = this.authService.user.firebaseId;

    this._oldNotify = this.db.collection(Constants.NotificheFirestoreService.BELL_PATH(id), ref => ref.where("show", "==", false));
  }

  readNotify() {
    this._newNotify.ref.get().then(
      (notifiche) => {
        notifiche.forEach(async (notifica) => {
          await notifica.ref.update({ show: false });
        })
      }
    )
  }
}
